<template>
  <div>
    <b-tabs content-class="mt-3">

      <b-tab title="Keywords" lazy>
        <bulk-keywords :selected-assets="selection"
                       :id-key="idKey"
                       @cancel="$emit('cancel')"
                       @done=""/>
      </b-tab>

      <b-tab title="Names">
        <bulk-name :id-key="idKey"
                   prop-key-name="name"
                   :selected-assets="selection"/>
      </b-tab>

      <b-tab title="Categories" lazy>
        <bulk-categories :id-key="idKey"
                         :selected-assets="selection"
                         :categories="categories"/>
      </b-tab>

      <b-tab title="Tags" lazy>
        <bulk-tags :selected-assets="selection"
                   :id-key="idKey"
                   @cancel="$emit('cancel')"
                   @done=""/>
      </b-tab>

      <b-tab title="Status">
        <bulk-status v-model="selection"
                     :id-key="idKey"
                     @cancel="$emit('cancel')"/>
      </b-tab>

      <b-tab title="Featured" lazy>
          <bulk-select :id-key="idKey"
                       :selected-assets="selection"
                       prop-name="rank_featured"
                       :prop-options="featuredOptions"/>
      </b-tab>

      <b-tab title="AI Approved" lazy>
        <bulk-select :id-key="idKey"
                     :selected-assets="selection"
                     prop-name="ai_approved"
                     :deactivate-usages="['editorial']"
                     :deactivate-statuses="['deactivated']"
                     deactivate-message="Some assets are not eligible for flagging as AI Approved"
                     :deactivate-prop-values="[true]"
                     :preselect-all="true"
                     :prop-options="featuredOptions"/>
      </b-tab>

      <b-tab title="Usage" lazy>
        <bulk-select :id-key="idKey"
                     :selected-assets="selection"
                     prop-name="usage"
                     :prop-options="usageOptions"/>
      </b-tab>

      <b-tab title="Exclusivity" lazy>
        <bulk-select :id-key="idKey"
                     :selected-assets="selection"
                     prop-name="exclusive"
                     :prop-options="exclusivityOptions"/>
      </b-tab>

      <b-tab title="Copyright">
        <bulk-name :id-key="idKey"
                   prop-key-name="copyright"
                   :selected-assets="selection"/>
      </b-tab>

      <b-tab title="Caption">
        <bulk-name :id-key="idKey"
                   prop-key-name="caption"
                   :selected-assets="selection"/>
      </b-tab>

      <b-tab title="Location">
        <bulk-name :id-key="idKey"
                   prop-key-name="location"
                   :selected-assets="selection"/>
      </b-tab>

      <b-tab title="Collections" lazy>
        <bulk-collection :selected-assets="selection"
                         :id-key="idKey"
                         @cancel="$emit('cancel')"
                         @done=""/>
      </b-tab>

      <b-tab title="Versions" lazy>
        <bulk-versions :submission-id="submissionId"
                       :selected-assets="selection"
                       :id-key="idKey"
                       @cancel="$emit('cancel')"/>
      </b-tab>

      <b-tab title="Release Forms" lazy v-if="source === 'submissions'">
        <bulk-release-forms :id-key="idKey"
                            :selected-assets="selection"
                            prop-name="exclusive"
                            :prop-options="exclusivityOptions"/>
      </b-tab>

      <b-tab title="Video Rotate" lazy>
        <bulk-rotation :id-key="idKey"
                       :selected-assets="selection"
                       @cancel="$emit('cancel')"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TagSelect from "../../../Common/TagSelect";
import BulkStatus from "./BulkStatus";
import BulkCollection from "./BulkCollection";
import BulkCategories from "./BulkCategories";
import BulkName from "./BulkName";
import BulkKeywords from "./BulkKeywords";
import BulkTags from "./BulkTags";
import BulkVersions from "./BulkVersions.vue";
import BulkSelect from "./BulkSelect.vue";
import BulkReleaseForms from "./BulkReleaseForms.vue";
import BulkRotation from "./BulkRotation.vue";

export default {
  components: {
    BulkRotation,
    BulkReleaseForms,
    BulkSelect,
    BulkVersions,
    BulkTags,
    BulkKeywords,
    BulkCategories,
    BulkName,
    BulkStatus,
    TagSelect,
    BulkCollection
  },
  // source must be search or submissions
  props: ['selection', 'categories', 'source', 'submissionId'],
  data() {
    return {
      name: "",
      selectedCategories: []
    }
  },

  computed: {

    usageOptions() {
      return [
        {text: "Commercial", value: "commercial"},
        {text: "Editorial", value: "editorial"},
      ]
    },

    exclusivityOptions() {
      return [
        {text: "Exclusive", value: true},
        {text: "Non Exclusive", value: false},
      ]
    },

    featuredOptions() {
      return [
        {text: "Yes", value: true},
        {text: "No", value: false},
      ]
    },

    idKey() {
      if (this.source === 'search') {
        return "objectID"
      }
      return "id"
    },

    uniqueAssetNames() {
      return [...new Set(this.selection.map(el => el.name).filter(el => el && el.length > 0))]
    }
  }
}
</script>